<template>
    <div ref="inputForDropMenu">
        <div>
            <input v-show="visibleDropdown" ref="jhCustomSelectInput" type="text" class="jh-custom-select-input"
                   :value="value" v-on:input="$emit('input', $event.target.value)"
                   @focus="showDropdownMenu(true)"
            >
            <div v-show="!visibleDropdown" class="jh-custom-select-input jh-custom-select-fake-input"
                 v-on:click="showDropdownMenu(true)">
                {{userSees}}
            </div>
            <div class="jh-custom-select-dropdown-switch-anchor">
                <div class="jh-custom-select-dropdown-switch">
                    <SVGCrossClearField class="clear-button" v-show="userSees"
                                        v-on:click.native="clearSelection()"/>
                </div>
                <div class="jh-custom-select-dropdown-switch" v-on:click="showDropdownMenu(!visibleDropdown)">
                    <SVGDropdownSwitchArrowUp v-if="visibleArrow" v-show="visibleDropdown"/>
                    <SVGDropdownSwitchArrowDown v-if="visibleArrow" v-show="!visibleDropdown"/>
                </div>
            </div>
        </div>
        <div class="jh-custom-select-dropdown-menu" v-show="visibleDropdown" :style="widthDropdownMenu">
            <vue-custom-scrollbar class="jh-custom-select-dropdown" @ps-y-reach-end="scrollReachEnd">
                <div class="jh-custom-select-option" v-for="(option, prop) in selectOptions"
                     v-on:click="selectOption(selectableParamCondition(option,prop), selectName(option,prop))">
                    {{selectName(option,prop)}}
                    <div class="jh-custom-select-option-description" v-if="selectDescription">{{selectDescription(option,prop)}}</div>
                </div>
                <div v-show="visibleMessageLoading" class="jh-custom-select-loader-grid">
                    <SpinnerTwo class="jh-custom-select-spinner"/>
                    <div class="jh-custom-select-loader-text">
                        Загрузка ...
                    </div>
                </div>
            </vue-custom-scrollbar>
        </div>
    </div>
</template>

<script>
    import SVGDropdownSwitchArrowUp from "../SVG/SVGDropdownSwitchArrowUp";
    import SVGDropdownSwitchArrowDown from "../SVG/SVGDropdownSwitchArrowDown";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import SpinnerTwo from "../SpinnerTwo";
    import SVGCrossClearField from "../SVG/SVGCrossClearField";

    export default {
        name: "JHCustomSelect",
        components: {
            SVGCrossClearField,
            SpinnerTwo,
            SVGDropdownSwitchArrowDown,
            SVGDropdownSwitchArrowUp,
            vueCustomScrollbar
        },
        props: {
            value: {                    // Нужен для работы v-model
                type: String
            },
            selectOptions:{},
            selectableParamCondition: {
                type: Function
            },
            selectDescription: {
                type: Function
            },
            selectName: {
                type: Function
            },
            selectedParamValue: {},
            visibleArrow: {
                type: Boolean,
                default: true
            },
            visibleMessageLoading: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                visibleDropdown: false,
                widthDropdownMenu: {
                    width: 'auto',
                },
            }
        },
        computed:{
            userSees(){
                for(let prop in this.selectOptions){
                    if(this.selectedParamValue === this.selectableParamCondition(this.selectOptions[prop], prop)){
                        return this.selectName(this.selectOptions[prop], prop);
                    }
                }
            },
        },
        methods: {
            clearSelection() {
                this.$emit('selected', null);
            },
            selectOption(param, name) {
                this.showDropdownMenu(false);
                this.$emit('selected', param);
                this.$emit('selectedName', name);
            },
            scrollReachEnd() {
                if (this.visibleDropdown)
                    this.$emit('scrollReachEnd');
            },
            showDropdownMenu(status) {
                if (status) {
                    this.widthDropdownMenu.width = this.$refs.inputForDropMenu.offsetWidth + 'px';
                }
                if (this.visibleDropdown !== status) {
                    this.$emit('focusOnInput', status);
                    this.visibleDropdown = status;
                }
            },
            eventListenerHandler(event) {
                const clickOnInputForDropMenu = this.$refs.inputForDropMenu.contains(event.target) || (this.$refs.inputForDropMenu === event.target);
                if (!clickOnInputForDropMenu)
                    this.showDropdownMenu(clickOnInputForDropMenu);
            }
        },
        updated() {
            if(this.visibleDropdown)
                this.$refs.jhCustomSelectInput.focus();
        },
        mounted() {
            document.addEventListener('click', this.eventListenerHandler);
        },
        destroyed() {
            document.removeEventListener('click', this.eventListenerHandler);
        }
    }
</script>

<style scoped>
    .jh-custom-select-input {
        width: available;
        width: -moz-available;
        width: -webkit-fill-available;
        padding: 10px;
        border: 1px solid #BDBDBD;
        font-size: 13px;
    }

    .jh-custom-select-input:hover {
        border-color: #828282;
    }

    .jh-custom-select-input:focus {
        border-color: #828282;
    }

    .jh-custom-select-fake-input {
        display: inline-block;
        height: 16px;
        font-size: 13px;
    }

    .jh-custom-select-dropdown-switch-anchor {
        position: relative;
        float: right;
        width: 0;
        height: 0;
        right: 55px;
        display: grid;
        grid-template-columns: auto auto;
    }

    .clear-button {
        width: 12px;
        height: 12px;
        color: #9d9d9d;
    }

    .jh-custom-select-dropdown-switch {
        width: 17px;
        /*position: absolute;*/
        display: inline-block;
        padding: 9px 5px 9px 5px;
        right: 30px;
        z-index: 10;
    }

    .jh-custom-select-dropdown {
        background-color: white;
        width: available;
        width: -moz-available;
        width: -webkit-fill-available;
        border: 1px solid #bdbdbd;
        border-top: 0;
        z-index: 10;
        max-height: 157px;
        overflow-y: auto;
        /*position: fixed;*/
    }

    .jh-custom-select-option {
        padding: 10px;
        font-size: 13px;
        /*display: grid;*/
        /*grid-template-columns: max-content auto;*/
        /*grid-column-gap: 20px;*/
        display: block;
        cursor: default;
    }

    .jh-custom-select-option:hover {
        background-color: #2670d6;
        color: white;
    }

    .jh-custom-select-option-description {
        color: #ACACAC;
    }

    .jh-custom-select-dropdown-menu{
        position: fixed;
        z-index: 99999;
    }

    .jh-custom-select-loader-grid {
        display: grid;
        grid-template-columns: 40px max-content;
        width: max-content;
        margin: 20px auto;
    }

    .jh-custom-select-loader-text {
        margin: -7px 0;
        font-size: 13px;
        color: #626262;
    }

    .jh-custom-select-spinner {
        font-size: 5px;
    }
</style>
